import { Page, PageHero } from "../components/Layout";
import { ContactMain, OfficesSection } from "../components/contact/ContactSections";

export default function Contact() {
  return (
    <Page testId="contact-page">
      <PageHero image="/assets/bg-contact.jpg" eyebrow="Contact Us" title={<>Let's build your <span className="text-[#D4AF37]">workforce together.</span></>} sub="Reach us at our head office in Mumbai or any of our branches in Ahmedabad, Jaipur, and Doha, Qatar." />
      <ContactMain />
      <OfficesSection />
    </Page>
  );
}